import Skeleton from '@mui/material/Skeleton';
import { Box } from 'shared/mui/Box';

export const MerchantShowAccountsFormSkeleton: React.FC = () => {
  return (
    <>
      <Box mb="15px">
        <Skeleton height={40} variant="rounded" width={150} />
      </Box>
      <Box sx={{ display: 'flex', width: '100%' }}>
        <Box
          sx={{
            display: 'flex',
            gap: '15px',
            flexDirection: 'column',
            paddingRight: '24px',
            width: '396px',
          }}
        >
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton height={40} key={i} variant="rounded" />
          ))}
        </Box>
        <Box sx={{ display: 'flex', gap: '15px', flexDirection: 'column', width: '707px' }}>
          <Skeleton height={40} variant="rounded" />
          <Skeleton height={160} variant="rounded" />
          <Skeleton height={160} variant="rounded" />
        </Box>
      </Box>
    </>
  );
};
